import type { ReactElement } from 'react';
import { Loader2 } from 'lucide-react';

interface AuthLoadingProps {
  message: string;
}

function AuthLoading({ message }: AuthLoadingProps): ReactElement {
  return (
    <div className="vtwo:flex vtwo:flex-col vtwo:items-center vtwo:gap-4 vtwo:text-sm vtwo:text-auth-muted">
      <Loader2 aria-hidden className="vtwo:size-8 vtwo:animate-spin vtwo:text-auth-primary" />
      <p>{message}</p>
    </div>
  );
}

export default AuthLoading;
